import {VNode} from "vue";
import {AEditor} from "@/views/editor/service/editor";
import {IActivityBusinessMeta} from "@/model/activity";
import {IInput} from "@/views/editor_old/module/sign/sign_v1";
import {CheckboxOptionType} from "ant-design-vue/es/checkbox/interface";
import {RadioGroupChildOption} from "ant-design-vue/es/radio/Group";
import {INotifyRole, IRule} from "@/views/editor/service/types";

export interface INewBusiness {
    new(editor: AEditor, meta: IActivityBusinessMeta): IBusiness;
}

export interface IBusiness {
    readonly icon: () => VNode;
    readonly title: string;
    readonly description: string;
    readonly implementations: RadioGroupChildOption[];
    readonly subs: CheckboxOptionType[];
    readonly meta: IActivityBusinessMeta

    /**
     * 新创建活动时初始化业务
     */
    resetMeta(): IBusiness

    roles(): INotifyRole[]
}

export interface IBizAtmosphere extends IBusiness {
    setRules(owner: string, rules: IRule[]): void
}

export type IBizPromotion = IBusiness

export type IBizChallenge = IBusiness

export interface IBizRaffle extends IBusiness {
    setPrizes(owner: string, prizes: unknown[]): void
}

export interface IBizCoupon extends IBusiness {
    set(owner: string, coupons: unknown[]): void
}

export type IBizProfitSharing = IBusiness

export type IBizRedEnvelope = IBusiness


export interface IBizSign extends IBusiness {
    set(owner: string, inputs: IInput[]): void
}

export abstract class ABusiness implements IBusiness {

    abstract icon(): VNode;
    readonly abstract title: string;
    readonly abstract description: string;
    readonly abstract implementations: RadioGroupChildOption[];
    readonly abstract subs: CheckboxOptionType[];

    protected constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
    }

    abstract resetMeta(): IBusiness

    roles(): INotifyRole[] {
        return []
    }
}